
import {Component, Mixins} from "vue-property-decorator";
import {formMixin, formOptionsMixin, formValidationMixin} from "../mixins";
import Select from "./Select.vue";
import {getModule} from "vuex-module-decorators";
import {SystemModule} from "@/store/modules";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class StateSelect extends Mixins(formMixin, formOptionsMixin, formValidationMixin) {
  get types() {
    return systemModule.states.map(x => ({label: x.name, value: x.code}));
  }
}
